import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import { DATE_RANGE_FILTER_LABEL } from 'src/common/consts/FilterPanelConsts';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';
import { IPinnableSelectFilterDefinition } from 'src/common/helpers/FiltersPanelHelper';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

const platformFilter: ISelectFilterDefinition = {
	id: 'platform',
	label: 'platform',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Platform',
		allSelectedPlaceholder: 'All platforms',
		someItemsSelectedText: (numberOfItems: number) => `Platforms (${numberOfItems})`,
		isMultiple: true,
		id: 'platform',
		label: 'Platform',
		listboxWidth: '140px'
	}
};

const appNameFilter: ISelectFilterDefinition = {
	id: 'appName',
	label: 'App Name',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'App Name',
		allSelectedPlaceholder: 'All App Names',
		someItemsSelectedText: (numberOfItems: number) => `App Names (${numberOfItems})`,
		isMultiple: true,
		id: 'appName',
		label: 'App Name',
		listboxWidth: '140px'
	}
};

const versionFilter: ISelectFilterDefinition = {
	id: 'versions',
	label: 'App Version',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Version',
		allSelectedPlaceholder: 'All App versions',
		someItemsSelectedText: (numberOfItems: number) => `Versions (${numberOfItems})`,
		isMultiple: true,
		id: 'versions',
		label: 'App Version',
		listboxWidth: '140px'
	}
};

const ownerFilter: ISelectFilterDefinition = {
	id: 'owner',
	label: 'owner',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Owner',
		allSelectedPlaceholder: 'All owners',
		someItemsSelectedText: (numberOfItems: number) => `Owners (${numberOfItems})`,
		isMultiple: true,
		id: 'owner',
		label: 'Owner',
		listboxWidth: '140px'
	}
};

const severityFilter: ISelectFilterDefinition = {
	id: 'severity',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Severity',
		allSelectedPlaceholder: 'All severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		id: 'severity',
		label: 'Severity',
		listboxWidth: '140px'
	}
};

const sessionsPeriodFilter: IPinnableSelectFilterDefinition = {
	id: 'sessionsPeriod',
	label: DATE_RANGE_FILTER_LABEL,
	filterType: 'select',
	defaultValue: [DEFAULT_PERIOD_OPTION],
	isPinned: true,
	componentProps: {
		placeholder: 'Select Sessions Period',
		isMultiple: false,
		id: 'sessionsPeriod',
		label: DATE_RANGE_FILTER_LABEL,
		listboxWidth: '140px'
	}
};

export const MfaSessionsPageFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	platformFilter,
	appNameFilter,
	versionFilter,
	ownerFilter,
	severityFilter,
	sessionsPeriodFilter
];
